<template>
    <div class="video-player">
        <vue-plyr ref="plyr" @timeupdate="videoTimeUpdated">
            <div data-plyr-provider="vimeo" :data-plyr-embed-id="source"></div>
        </vue-plyr>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: ['activity', 'closing'],

    data() {
        return {
            source: '',
            id_course: '',
            id_trail: '',
            interval: null,
            current_time: 0,
            total_time: '',
            changed_time: false
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        player () { return this.$refs.plyr.player }
    },

    methods: {
        sendPosition() {
            if (this.current_time != 0) {
                let fd = new FormData()
                fd.append('current_time', this.current_time)
                fd.append('total_time', this.player.duration)
                fd.append('id_group_training_module', this.activity.type_id)

                let url = ''
                if (this.id_trail == "") {
                    url = `/etraining_courses/group_training/${this.id_course}/set_group_training_module_user_progress/`
                }
                else {
                    url = `/etraining_trails/trail/${this.id_trail}/group_training/${this.id_course}/set_group_training_module_user_progress/`
                }

                this.$axios.post(url, fd, this.getHeader)
                .then(response => {

                })
                .catch(e => {
                    console.log(e)
                })
            }
        },

        playVideo() {
            if (!this.changed_time) {
                this.player.currentTime = this.activity.current_time
                this.changed_time = true
            }

            this.interval = setInterval(() => {
                this.sendPosition()
            }, 60000)
        },

        pauseVideo() {
            this.sendPosition()
            clearInterval(this.interval)
        },

        videoTimeUpdated(val) {
            this.current_time = val.detail.plyr.currentTime
        },

        vimeoParser(url){
            let regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/
            let match = url.match(regExp)
            this.source = match[5]
        }
    },

    watch: {
        closing: function(val) {
            if (val == true) {
                this.sendPosition()
                clearInterval(this.interval)
                this.changed_time = false
                this.$emit('positionSent')
            }
        }
    },

    mounted () {
        this.player.on('timeupdate', (val) => this.videoTimeUpdated(val))
        this.player.on('play', (val) => this.playVideo())
        this.player.on('pause', (val) => this.pauseVideo())
    },

    created() {
        if( this.$route.params.id_trail) this.id_trail = this.$route.params.id_trail
        if( this.$route.params.id) this.id_course = this.$route.params.id
        this.id_course = this.$route.params.id
        this.vimeoParser(this.activity.resource)
    }
}
</script>

<style lang="stylus" scoped>

</style>
